/**
 * @enum {enumSocialMediaPostType} Represents different possible types of social media posts
 */
export enum enumSocialMediaPostType {
  Undefined = 'Undefined',
  FacebookPost = 'FacebookPost', // a Facebook Post (as opposed to a Facebook Reel or Facebook Video)
  FacebookReel = 'FacebookReel', // a Facebook Reel
  FacebookVideo = 'FacebookVideo', // a Facebook Video
  Gab = 'Gab',
  Instagram = 'Instagram',
  LinkedIn = 'LinkedIn',
  Pinterest = 'Pinterest',
  TikTok = 'TikTok',
  TruthSocial = 'TruthSocial',
  XOrTwitter = 'XOrTwitter',
  YouTube = 'YouTube'
}

